var chunkMapping = {
	"874": [
		8112,
		22158,
		24800,
		40541,
		77855,
		88785,
		88926,
		99154
	],
	"875": [
		81875
	]
};
var idToExternalAndNameMapping = {
	"8112": [
		"default",
		"./GetApi",
		14141
	],
	"22158": [
		"default",
		"./PostApi",
		14141
	],
	"24800": [
		"default",
		"./Store",
		23183
	],
	"40541": [
		"default",
		"./PutApi",
		14141
	],
	"77855": [
		"default",
		"./DeleteApi",
		14141
	],
	"81875": [
		"default",
		"./LogoUpHircasa",
		14141
	],
	"88785": [
		"default",
		"./NotificationsContext",
		14141
	],
	"88926": [
		"default",
		"./ApiConfig",
		14141
	],
	"99154": [
		"default",
		"./PatchApi",
		14141
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}